const counts = [1, 2, 3, 4, 5, 10, 20, 25, 50, 100, 200, 500, 1000];

const RandomTextGeneratorOptions = (
  {
    options: {
      length = 20,
      characters = "alphanumeric",
      casing = "mixed",
      count = 20,
    } = {},
    onChange,
    strings,
    toolStrings,
  } = {
    options: {},
  }
) => {
  const allCharacters = [
    { name: "alphanumeric", display: toolStrings.alphanumeric },
    { name: "alphabetic", display: toolStrings.alphabetic },
    { name: "numeric", display: toolStrings.numeric },
    { name: "hex", display: toolStrings.hex },
    { name: "binary", display: toolStrings.binary },
    { name: "octal", display: toolStrings.octal },
  ];

  const allCases = [
    { name: "mixed", display: toolStrings.mixed },
    { name: "uppercase", display: toolStrings.uppercase },
    { name: "lowercase", display: toolStrings.lowercase },
  ];

  return (
    <div className={"row p-0 m-1 pb-2 d-flex flex-row"}>
      <div className="col-12 col-sm-6 col-md-3">
        <label forhtml="lengthLabel">{strings.Length}</label>
        <input
          className="form-control"
          type="number"
          value={isNaN(length) ? "" : length}
          onChange={({ target: { value } }) =>
            onChange({
              length:
                parseInt(value) < 0
                  ? 0
                  : parseInt(value) > 10000
                  ? 9999
                  : parseInt(value),
              characters,
              count,
              casing,
            })
          }
        />
      </div>
      <div className="col-12 col-sm-6 col-md-3">
        <label forhtml="characters-label ">{toolStrings.characters}</label>
        <select
          className="form-select"
          aria-label="characters-label"
          onChange={({ target: { value } }) =>
            onChange({ characters: value, length, count, casing })
          }
          value={characters}
        >
          {allCharacters.map(({ name, display }) => (
            <option key={name} value={name}>
              {display}
            </option>
          ))}
        </select>
      </div>
      <div className="col col-6 col-md-3">
        <label forhtml="typeLabel ">{toolStrings.casing}</label>
        <select
          className="form-select"
          aria-label="type"
          onChange={({ target: { value } }) =>
            onChange({ casing: value, length, count, characters })
          }
          value={casing}
        >
          {allCases.map(({ name, display }) => (
            <option key={name} value={name}>
              {display}
            </option>
          ))}
        </select>
      </div>

      <div className="col col-6 col-md-3">
        <label forhtml="countLabel">{strings.Count}</label>
        <select
          className="form-select"
          onChange={({ target: { value } }) =>
            onChange({ characters, count: parseInt(value), length, casing })
          }
          value={count}
          aria-label="Count"
        >
          {counts.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default RandomTextGeneratorOptions;
